import { IEventTime, IOrganization, ISession } from "./common.types";

export const defaultEventTime: IEventTime = {
	event_timing_id: 0,
	event_timing_uuid: "",
	event_name: "",
	description: "",
	status: "INACTIVE",
	created_by_uuid: "",
	created_by_name: "",
	modified_by_uuid: "",
	modified_by_name: "",
	create_ts: "",
	insert_ts: "",
};

export const defaultOrganization: IOrganization = {
	organizations_id: 0,
	organizations_unique_id: 0,
	organizations_uuid: "",
	organizations_name: "",
	status: "INACTIVE",
	created_by_uuid: "",
	created_by_name: "",
	modified_by_uuid: "",
	modified_by_name: "",
	create_ts: null,
	insert_ts: "",
};

export const defaultSessionInfo: ISession = {
	session_info_id: 0,
	session_info_unique_id: 0,
	session_info_uuid: "",
	session_name: "",
	session_duration_in_years: "0",
	session_starting_date: "",
	session_ending_date: "",
	status: "INACTIVE", // Default status can be adjusted
	created_by_uuid: "",
	created_by_name: "",
	modified_by_uuid: "",
	modified_by_name: "",
	create_ts: "",
	insert_ts: "",
};
